import { capitalize } from 'lodash';

import { InvitationView as PartyInvitationView } from 'src/components/Escrow/Invitation';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';

type Props = {
  partyType: EscrowPartyTypeEnum;
};

const InvitationView = ({ partyType }: Props) => {
  const {
    softwareEscrow: { escrowInvitation },
  } = useSoftwareEscrow();

  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h2 className="text-lg font-bold">{capitalize(partyType)} organization & primary contact</h2>
        <p className="text-muted-foreground text-sm">
          The {partyType} organization and their primary point of contact. This person will be invited to the platform,
          and be able to add members, representatives and signatories for their organization.
        </p>
      </div>
      <PartyInvitationView
        companyName={escrowInvitation?.companyName ?? ''}
        userName={escrowInvitation?.userName ?? ''}
        userEmail={escrowInvitation?.userEmail ?? ''}
      />
    </div>
  );
};

export default InvitationView;
